let elTableBody = ELEMENT.Table.components.TableBody;

const tableRow = {
  name: "DsfElTableRow",
  inject: {
    $dsfElTableBody: {
      default: null
    },
    $dsfElTable: {
      default: null
    }
  },
  data() {
    return {
      isRendered: true
    };
  },
  props: {
    rowData: {
      type: Object,
      default() {
        return null;
      }
    },
    index: {
      type: Number,
      default: 0
    },
    treeRowData: {
      type: Object,
      default() {
        return null;
      }
    },
    state: {
      type: Number,
      defalt: true
    }
    // lazy: {
    //   type: Boolean,
    //   default: false
    // }
  },
  computed: {
    // $inRange() {
    //   let inRange = true;
    //   const table = this.$dsfElTable;
    //   if (table.useShowRangeData) {
    //     const { startIndex, endIndex } = table;
    //     if (startIndex > this.index || endIndex < this.index) {
    //       inRange = false;
    //     }
    //   }
    //   return inRange;
    // }
  },
  created() {
    this.body = this.$dsfElTableBody;
    this.table = this.$dsfElTable;
  },
  // updated() {
  //   console.log("rowupdated", this.index);
  // },
  methods: {
    renderRowSlot(h, props, row, treeRowData, $index) {
      const { treeIndent, columns, firstDefaultColumnIndex, table, fixedMark } = this.body;
      // const columnsHidden =this. columns.map((column, index) => this.isColumnHidden(index));
      const columnsHidden = this.body.columnsHidden;
      let data = props.data;
      let self = this.body;
      //加载表格内容
      let cellMap = {};
      let renderColumns = columns.map((column, cellIndex) => {
        let mark = true;
        let isLeft = self.fixedMark == "left" && self.getFixed(column.fixed) != "left";
        let isRight = self.fixedMark == "right" && self.getFixed(column.fixed) != "right";
        if (isLeft || isRight) {
          mark = false;
        }
        let { rowspan, colspan } = self.getSpan(row, column, $index, cellIndex);
        if (!rowspan || !colspan) {
          return null;
        }
        const columnData = { ...column };
        columnData.realWidth = self.getColspanRealWidth(columns, colspan, cellIndex);
        const data = {
          store: self.store,
          _self: self.context || self.table.$vnode.context,
          column: columnData,
          row,
          $index
        };
        if (cellIndex === firstDefaultColumnIndex && treeRowData) {
          data.treeNode = {
            indent: treeRowData.level * treeIndent,
            level: treeRowData.level
          };
          if (typeof treeRowData.expanded === "boolean") {
            data.treeNode.expanded = treeRowData.expanded;
            // 表明是懒加载
            if ("loading" in treeRowData) {
              data.treeNode.loading = treeRowData.loading;
            }
            if ("noLazyChildren" in treeRowData) {
              data.treeNode.noLazyChildren = treeRowData.noLazyChildren;
            }
          }
        }
        let fixedInfo = self.isColumnFixed(cellIndex);
        let fastScroll = self.table.fastScroll;

        let notShowCellContent = false;
        let columnInRange = true;
        let renderCellContent = null;
        //如果是虚拟滚动，判断当前单元格是否超出可显示的列范围
        let isRender = true;
        if (this.table.useVirtulScroll) {
          if (this.table.startColIndex > cellIndex || this.table.endColIndex < cellIndex) {
            columnInRange = false;
          }
          //如果当前列是一个冻结列，强制显示
          columnInRange =
            fixedInfo.pos == "left" || fixedInfo.pos == "right" ? true : columnInRange;
          if (notShowCellContent) {
            renderCellContent = null;
          } else {
            if (mark) {
              //不在可视区域的列不显示
              isRender = columnInRange;
            } else {
              isRender = false;
            }
            if (isRender) {
              renderCellContent = [
                this.renderCell(column, data, self.$createElement, columnsHidden, cellIndex)
              ];
            } else {
              renderCellContent = null;
            }
          }
        } else {
          if (column.type == "selection") {
            isRender = props.ready >= 2;
          } else if (column.fixed == "right") {
            //ready小于2时，不渲染右侧冻结列内容
            isRender = props.ready >= 2;
          } else {
            //ready大于等于1时，渲染列内容
            isRender = props.ready >= 1;
          }
          if (isRender) {
            renderCellContent = [
              this.renderCell(column, data, self.$createElement, columnsHidden, cellIndex)
            ];
          } else {
            renderCellContent = [];
          }
        }
        let cell = (
          <td
            style={[self.getCellStyle($index, cellIndex, row, column)]}
            class={self.getCellClass($index, cellIndex, row, column)}
            rowspan={rowspan}
            colspan={colspan}
            on={{
              mouseenter: ($event) => self.handleCellMouseEnter($event, row),
              mouseleave: self.handleCellMouseLeave
            }}
          >
            {renderCellContent}
          </td>
        );
        return cell;
      });
      return renderColumns;
    },
    renderProxyCell(h) {
      const { columns } = this.$dsfElTableBody;
      return h(
        "td",
        {
          attrs: {
            rowspan: 1,
            colspan: columns.length
          }
        },
        [h()]
      );
    },
    renderCell(column, data, h, columnsHidden, cellIndex) {
      return column.renderCell.call(this.body._renderProxy, h, data, columnsHidden[cellIndex]);
    }
  },
  render(h) {
    let cells = [];
    // let ready = 2;
    let inRange = true;
    const body = this.$dsfElTableBody;
    const table = this.$dsfElTable;
    // if (table.useVirtulScroll || table.useShowRangeData) {
    //   if (this.index >= table.startIndex && this.index <= table.endIndex) {
    //     inRange = true;
    //   } else {
    //     inRange = false;
    //   }
    // }
    // if (table.useShowRangeData) {
    //   ready = this.$dsfElTable.dataReady[this.index];
    // }
    let ready = this.state;
    let isRenderCells = true;
    if (table.useVirtulScroll && table.fastScroll) {
      isRenderCells = false;
    } else {
      isRenderCells = !(ready < 1);
    }

    if (!isRenderCells) {
      cells = [this.renderProxyCell(h)];
    } else {
      const props = {
        self: this.$parent,
        data: this.rowData,
        ready: ready
        // inRange: inRange
      };
      cells = this.renderRowSlot(h, props, this.rowData, this.treeRowData, this.index);
    }

    return h(
      "tr",
      {
        attrs: {
          ready: ready
        }
      },
      cells
    );
  }
};

export default {
  name: "DsfElTableBody",
  mixins: [elTableBody],
  provide() {
    return {
      $dsfElTableBody: this
    };
  },
  inject: {
    $dsfElTable: {
      default: null
    }
  },
  components: {
    trow: tableRow
  },
  computed: {
    fixedMark() {
      return this.getFixed(this.fixed);
    },
    table() {
      return this.$dsfElTable;
    }
    // tableUseVirtulScroll() {
    //   return this.table.useVirtulScroll;
    // }
  },
  created() {
    this.columnsHidden = null;
    this.$table = this.table;
    this.table.tbodys[this.fixedMark] = this;
  },
  updated() {},
  mounted() {
    // 监听表体尺寸变
    const useOptimization = this.table.useVirtulScroll || this.table.useShowRangeData;
    if (!useOptimization && this.fixedMark == "main") {
      this.bodyObserver = new ResizeObserver(() => {
        this.debounceSyncRowHeight();
      });
      this.startResizeObserver();
    }
    this.debounceSyncRowHeight = _.debounce(this._syncRowHeight, 200);
  },
  methods: {
    isColumnHidden(index) {
      if (this.table.isSticky) {
        return false;
      } else {
        return elTableBody.methods.isColumnHidden.call(this, index);
      }
    },
    isColumnFixed(index) {
      let info = { pos: null, last: false };
      if (index < this.leftFixedLeafCount) {
        info.pos = "left";
        info.last = index >= this.leftFixedLeafCount - 1;
      } else if (index >= this.columnsCount - this.rightFixedLeafCount) {
        info.pos = "right";
        info.last = index == this.columnsCount - this.rightFixedCount;
      } else {
        info.pos = null;
      }
      return info;
    },
    startResizeObserver() {
      this.bodyObserver && this.bodyObserver.observe(this.$refs.body);
    },
    endResizeObserver() {
      this.bodyObserver && this.bodyObserver.unobserve(this.$refs.body);
    },
    _syncRowHeight() {
      const useOptimization = this.table.useVirtulScroll || this.table.useShowRangeData;
      if (!useOptimization && this.fixedMark == "main" && this.data.length > 0) {
        this.syncRowHeight();
      }
    },
    syncRowHeight() {
      if (!this.table.isSticky) {
        let heights = [];
        let tr = this.$refs.body.querySelectorAll(".el-table__row");
        tr.forEach((row, i) => {
          let index = row.getAttribute("row-index");
          row.style.height = "auto";
          let realHeight = row.getBoundingClientRect().height;
          heights.push({
            elm: row,
            index: i,
            height: realHeight
          });
        });
        let left_tr =
          this?.table?.$refs?.fixedBodyWrapper?.querySelectorAll?.(".el-table__row") || null;
        let right_tr =
          this?.table?.$refs?.rightFixedBodyWrapper?.querySelectorAll?.(".el-table__row") || null;
        //将表格主体的行高同步给左右两侧冻结区域表格行高
        _.each(heights, (h) => {
          if (left_tr && left_tr.length > 0 && left_tr[h.index]) {
            left_tr[h.index].style.height = this.unitSize(h.height);
          }
          if (right_tr && right_tr.length > 0 && right_tr[h.index]) {
            right_tr[h.index].style.height = this.unitSize(h.height);
          }
        });
      }
    },
    getFixed(fixed) {
      if (fixed == "left" || fixed == "right") {
        return fixed;
      } else if (fixed === true) {
        return "left";
      } else {
        return "main";
      }
    },
    //重写行render函数，
    rowRender(row, $index, treeRowData) {
      const { treeIndent, columns, firstDefaultColumnIndex, table, fixedMark, _self } = this;
      // const columnsHidden = columns.map((column, index) => this.isColumnHidden(index));
      const columnsHidden = this.columnsHidden;
      const rowClasses = this.getRowClass(row, $index);
      let display = true;
      if (treeRowData) {
        rowClasses.push("el-table__row--level-" + treeRowData.level);
        display = treeRowData.display;
      }
      // 指令 v-show 会覆盖 row-style 中 display
      // 使用 :style 代替 v-show https://github.com/ElemeFE/element/issues/16995
      let displayStyle = display
        ? null
        : {
          display: "none"
        };
      let h = this.$createElement;

      let rowStyle = {};
      let height = "";
      let state = 2;
      const { useVirtulScroll, useShowRangeData } = this.table;
      const useOptimization = useVirtulScroll || useShowRangeData;
      if (useOptimization) {
        height = this.unitSize(this.table.minRowHeight);
        rowStyle.height = height;
        state = 0;
        if (useShowRangeData) {
          state = this.$dsfElTable.dataReady[$index];
        }
        if (this.table.startIndex <= $index && this.table.endIndex >= $index) {
          state = 2;
        }
      }
      return h("trow", {
        style: [displayStyle, this.getRowStyle(row, $index), rowStyle],
        class: rowClasses,
        attrs: {
          "row-index": $index
        },
        props: {
          rowData: row,
          index: $index,
          treeRowData: treeRowData,
          state: state
        },
        key: table.useVirtulScroll ? $index : this.getKeyOfRow(row, $index),
        nativeOn: {
          dblclick: ($event) => this.handleDoubleClick($event, row),
          click: ($event) => this.handleClick($event, row),
          contextmenu: ($event) => this.handleContextMenu($event, row),
          mouseenter: (_) => this.handleMouseEnter($index),
          mouseleave: this.handleMouseLeave
        }
      });
    },
    getCellStyle(rowIndex, columnIndex, row, column) {
      let cellStyle = this.table.cellStyle || {};
      let result = cellStyle;
      if (typeof cellStyle === "function") {
        result = cellStyle.call(null, {
          rowIndex,
          columnIndex,
          row,
          column
        });
      }
      if (this.table.isSticky) {
        let info = this.isColumnFixed(columnIndex);
        let pos = info.pos;
        if (pos == "left") {
          let sum = 0;
          for (let i = 0; i < columnIndex; i++) {
            sum += this?.columns?.[i]?.realWidth || this?.columns?.[i]?.width || 0;
          }
          result[pos] = dsf.unitSize(sum);
          result.position = "sticky";
          result["z-index"] = 2;
        } else if (pos == "right") {
          let sum = 0;
          for (let i = this.columnsCount; i > columnIndex; i--) {
            sum += this?.columns?.[i]?.realWidth || this?.columns?.[i]?.width || 0;
          }
          result[pos] = dsf.unitSize(sum);
          result.position = "sticky";
          result["z-index"] = 2;
        }
      }
      return result;
    },
    getCellClass(rowIndex, columnIndex, row, column) {
      let classes = elTableBody.methods.getCellClass.call(this, rowIndex, columnIndex, row, column);
      if (this.table.isSticky) {
        let info = this.isColumnFixed(columnIndex);
        if (info.pos === "left" && info.last) {
          classes += " el-table-fixed-last";
        } else if (info.pos == "right" && info.last) {
          classes += " el-table-fixed-right-last";
        }
      }
      return classes;
    }
  },
  beforeDestroy() {
    delete this.$table.tbodys[this.fixedMark];
    delete this.$table;
    this.bodyObserver && this.bodyObserver.disconnect();
  },
  render(h) {
    const data = this.data || [];
    let acc = [];
    let rows = [];
    let { columns } = this;
    this.columnsHidden = null;
    this.columnsHidden = columns.map((column, index) => this.isColumnHidden(index));
    if (this.table.useVirtulScroll) {
      let pageData = this.data.slice(this.table.startIndex, this.table.endIndex + 1);
      _.each(pageData || [], (row, i) => {
        let index = this.table.startIndex + i;
        let rowVnode = this.wrappedRowRender(row, index);
        rows.push(rowVnode);
      });
    } else {
      rows = this.data.reduce((acc, row) => {
        let rowVnode = this.wrappedRowRender(row, acc.length);
        return acc.concat(rowVnode);
      }, []);
    }
    let vnodes = (
      <table class="el-table__body" cellspacing="0" cellpadding="0" border="0">
        <colgroup>
          {this.columns.map((column) => (
            <col name={column.id} key={column.id} />
          ))}
        </colgroup>
        <tbody ref="body">
          {rows}
          {/* <el-tooltip effect={this.table.tooltipEffect} placement="top" ref="tooltip" content={this.tooltipContent}></el-tooltip> */}
        </tbody>
      </table>
    );
    return vnodes;
  }
};
